import ApiClient from './ApiClient'

const API_NAME = 'WeConnect'
const client = new ApiClient(API_NAME)

/**
 * 施行後アンケート系API
 */
export default {
  /**
   * 施行後アンケートリストを取得する
   * @param {number} businessId 案件ID
   * @returns {Promise<any>} レスポンス
   */
  afterSurveys(businessId) {
    return client.get(`/business/${businessId}/after-survey`)
  },

  /**
   * 施行後アンケートの質問・回答内容を取得する
   * @param {number} businessId 案件ID
   * @param {number} afterSurveyId 施行後アンケートID
   * @returns {Promise<any>} レスポンス
   */
  questions(businessId, afterSurveyId) {
    return client.get(`/business/${businessId}/after-survey/${afterSurveyId}/question`)
  },

  /**
   * 施行後アンケートの回答を登録・更新する
   * @param {number} businessId 案件ID
   * @param {number} afterSurveyQuestionId 施行後アンケート質問ID
   * @param {object} data 回答データ
   * @returns {Promise<any>} レスポンス
   */
  answer(businessId, afterSurveyQuestionId, data) {
    const url = `/business/${businessId}/after-survey-question/${afterSurveyQuestionId}/answer`
    return client.put(url, data)
  },

  /**
   * 施行後アンケートの回答ヘッダを登録・更新する
   * @param {number} businessId 案件ID
   * @param {number} afterSurveyId 施行後アンケートID
   * @returns {Promise<any>} レスポンス
   */
  send(businessId, afterSurveyId) {
    return client.put(`/business/${businessId}/after-survey/${afterSurveyId}/answer-header`)
  }
}
